import { useParams } from 'react-router-dom';
import { useCachedAPI } from '../../state';
// Kept in a leaf module (only depends on ../../state) so callers outside the annual
// report — e.g. the wizard — can invalidate/read the cached summary without importing
// the heavy annual/selectors chain (report/resourcing -> report/selectors -> ...),
// which would introduce a module-init cycle.
export var SUMMARY_API = '/api/report/summary?basePlanId={basePlanId}';
// basePlanIdOverride lets callers outside the /report/:basePlanId route (e.g. the
// wizard after a recalculation) target another plan's cached summary — its cache key
// must match the value the report page fetches with, so pass the same basePlanId.
export var useSummaryReportAPI = function (basePlanIdOverride) {
  var basePlanId = useParams().basePlanId;
  return useCachedAPI(SUMMARY_API, {
    basePlanId: basePlanIdOverride !== null && basePlanIdOverride !== void 0 ? basePlanIdOverride : basePlanId
  });
};